/**
 * O mudo dos sons de aviso NESTE aparelho (D196), persistido em `localStorage`.
 *
 * A chave é a mesma do alerta de pedido de antes da M2-F3, de propósito: quem já tinha silenciado o tablet da
 * cozinha continua silenciado.
 *
 * ⚠️ `localStorage` lança em modo privado de alguns navegadores e quando a cota estoura. Nenhuma destas funções
 * pode derrubar o painel por causa de uma preferência de som.
 */
const MUTED_STORAGE_KEY = 'hmax-order:board-alert-muted';

export function readAlertSoundMuted(): boolean {
  try {
    return globalThis.localStorage?.getItem(MUTED_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function storeAlertSoundMuted(muted: boolean): void {
  try {
    globalThis.localStorage?.setItem(MUTED_STORAGE_KEY, String(muted));
  } catch {
    // Mudo em memória continua valendo pela sessão: a persistência é conveniência.
  }
}
